import { useEffect, useRef } from "react";
import moment from "moment";
import * as d3 from "d3";
import figureTimeline from "../lib/figureTimeline";
import locationTimeline from "../lib/locationTimeline";
import { useRouter } from "next/router";

export default function Timeline({ stops, specification, onHover = null }) {
  const canvasRef = useRef();
  const canvasWrapperRef = useRef();
  const router = useRouter();

  const drawTimeScale = () => {
    const container = d3.select(".timeline-container");

    if (!container || !container.node()) return;

    const containerSize = container.node().getBoundingClientRect();
    const outerWidth = containerSize.width;
    const outerHeight = containerSize.height;

    container.selectAll("svg").remove();

    const svgChart = container
      .append("svg")
      .attr("width", outerWidth)
      .attr("height", outerHeight)
      .attr("class", "svg-plot overflow-visible")
      .attr("pointer-events", "none")
      .append("g")
      .attr("transform", `translate(${containerSize.width / 2}, 0)`);

    const y = d3
      .scaleTime()
      .domain([new Date("1750"), new Date("1880")])
      .range([0, outerHeight])
      .nice();
    const yAxis = d3.axisLeft(y);
    svgChart.append("g").style("font-weight", "bold").style("color", "#777").call(yAxis);
  };

  useEffect(() => {
    drawTimeScale();
    window.addEventListener("resize", drawTimeScale);
    return () => window.removeEventListener("resize", drawTimeScale);
  }, []);

  useEffect(() => {
    if (canvasRef.current && stops) {
      if (specification == "figure")
        figureTimeline.drawTimeline(stops, canvasRef.current, handleFigureTimelineClick);
      if (specification == "location") {
        locationTimeline.graphSetup(stops, canvasRef.current, onHover);
      }
    }

    return () => {
      if (specification == "location") {
        locationTimeline.remove();
      }
      if (specification == "figure") {
        figureTimeline.remove();
      }
    };
  }, [canvasRef.current, stops]);

  const handleFigureTimelineClick = (date) => {
    if (date) {
      const dateString = moment(date).format("MM-DD-YYYY");
      const url = {
        pathname: router.pathname,
        query: { ...router.query, time: dateString },
      };
      router.replace(url, url, { shallow: true });
    }
  };

  return (
    <div
      className="timeline-container map-overlay absolute left-0 bottom-0 w-32 xl:w-40 h-full overflow-visible cursor-pointer"
      id={specification === "location" ? "location-timeline" : ""}
    >
      {specification === "figure" ? (
        <div
          className="w-full h-full absolute top-0 left-0 flex flex-row justify-center"
          style={{ pointerEvents: "none" }}
        >
          <canvas
            className="w-1/2 h-full absolute bottom-0"
            ref={canvasRef}
            style={{
              zIndex: -1,
              width: 92,
              pointerEvents: "auto",
            }}
          />
        </div>
      ) : (
        <div
          className="w-full h-full absolute bottom-0 left-0 flex flex-row justify-center"
          style={{ pointerEvents: "none" }}
          ref={canvasWrapperRef}
        >
          <canvas
            className="w-3/4 h-full absolute bottom-0"
            ref={canvasRef}
            style={{
              zIndex: -1,
              pointerEvents: "auto",
            }}
          />
        </div>
      )}
    </div>
  );
}
